// extracted by mini-css-extract-plugin
export var container = "_kx-0";
export var dotAnimation = "_kx-2";
export var dotsLoading = "_kx-1";